import { create } from 'zustand'

const initialState = {
  chatbotContext: "",
}

const useChatbotStore = create((set) => ({
  ...initialState,
  setChatbotContext: (chatbotContext) => set({ chatbotContext: JSON.stringify(chatbotContext) }),
  resetChatbotContext: () => set(initialState),
}))

export default useChatbotStore;